import React from "react";
import {
  Stack,
  Group,
  ActionIcon,
  Text,
  Select,
  Box,
  ComboboxItem,
} from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";

interface FontOption extends ComboboxItem {
  fontFamily: string;
}

const AVAILABLE_FONTS: FontOption[] = [
  { value: "Arial", label: "Arial", fontFamily: "Arial" },
  { value: "Helvetica", label: "Helvetica", fontFamily: "Helvetica" },
  {
    value: "Times New Roman",
    label: "Times New Roman",
    fontFamily: "Times New Roman, serif",
  },
  { value: "Georgia", label: "Georgia", fontFamily: "Georgia, serif" },
  { value: "Verdana", label: "Verdana", fontFamily: "Verdana, sans-serif" },
  {
    value: "Courier New",
    label: "Courier New",
    fontFamily: "Courier New, monospace",
  },
  {
    value: "Jacquard 10",
    label: "Jacquard 10",
    fontFamily: "Jacquard 10, sans-serif",
  },
  { value: "Roboto", label: "Roboto", fontFamily: "Roboto, sans-serif" },
  {
    value: "Open Sans",
    label: "Open Sans",
    fontFamily: "Open Sans, sans-serif",
  },
  { value: "Lato", label: "Lato", fontFamily: "Lato, sans-serif" },
  {
    value: "Montserrat",
    label: "Montserrat",
    fontFamily: "Montserrat, sans-serif",
  },
  {
    value: "Playfair Display",
    label: "Playfair Display",
    fontFamily: "Playfair Display, serif",
  },
  {
    value: "Merriweather",
    label: "Merriweather",
    fontFamily: "Merriweather, serif",
  },
  { value: "Poppins", label: "Poppins", fontFamily: "Poppins, sans-serif" },
  { value: "Raleway", label: "Raleway", fontFamily: "Raleway, sans-serif" },
  { value: "Inter", label: "Inter", fontFamily: "Inter, sans-serif" },
  {
    value: "Source Sans Pro",
    label: "Source Sans Pro",
    fontFamily: "Source Sans Pro, sans-serif",
  },
  { value: "Nunito", label: "Nunito", fontFamily: "Nunito, sans-serif" },
  { value: "Ubuntu", label: "Ubuntu", fontFamily: "Ubuntu, sans-serif" },
  { value: "Lora", label: "Lora", fontFamily: "Lora, serif" },
];

interface FontsSectionProps {
  headingFont: string;
  bodyFont: string;
  onHeadingFontChange: (font: string | null) => void;
  onBodyFontChange: (font: string | null) => void;
  onBack: () => void;
}

const FontsSection: React.FC<FontsSectionProps> = ({
  headingFont,
  bodyFont,
  onHeadingFontChange,
  onBodyFontChange,
  onBack,
}) => {
  return (
    <Stack gap="md">
      <Group justify="space-between" align="center">
        <ActionIcon variant="subtle" onClick={onBack}>
          <IconChevronLeft size={16} />
        </ActionIcon>
        <Text fw={600} size="lg">
          Fonts
        </Text>
      </Group>

      <Stack gap="sm">
        <Box>
          <Text size="sm" fw={500} mb="xs">
            Heading
          </Text>
          <Select
            value={headingFont}
            onChange={onHeadingFontChange}
            data={AVAILABLE_FONTS}
            placeholder="Select a font"
            searchable
            renderOption={({ option }) => (
              <Text style={{ fontFamily: (option as FontOption).fontFamily }}>
                {option.label}
              </Text>
            )}
            clearable
          />
        </Box>

        <Box>
          <Text size="sm" fw={500} mb="xs">
            Body
          </Text>
          <Select
            value={bodyFont}
            onChange={onBodyFontChange}
            data={AVAILABLE_FONTS}
            placeholder="Select a font"
            searchable
            renderOption={({ option }) => (
              <Text style={{ fontFamily: (option as FontOption).fontFamily }}>
                {option.label}
              </Text>
            )}
            clearable
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default FontsSection;
